

export class ProfessionalTaxDto implements IProfessionalTaxDto {
    id!: number;
    minAmount!: number;
    maxAmount!: number;
    ptAmount!: number;
    isActive!: boolean;

    constructor(data?: IProfessionalTaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.minAmount = _data["minAmount"];
            this.maxAmount = _data["maxAmount"];
            this.ptAmount = _data["ptAmount"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProfessionalTaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProfessionalTaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["minAmount"] = this.minAmount;
        data["maxAmount"] = this.maxAmount;
        data["ptAmount"] = this.ptAmount;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IProfessionalTaxDto {
    id: number;
    minAmount: number;
    maxAmount: number;
    ptAmount: number;
    isActive: boolean;
}

